<template>
  <div class="app-container" v-loading='loading'>
    <cart-course :timetable_id="timetable_id" :date="date" :key="key"/>
    <email-modal v-if="dialogVisible" :dialogVisible="dialogVisible" :userId="user_id" @dialogVisible="onDialogVisible" />
    <goals-modal v-if="dialog" :dialog="dialog" :enrolment_id="enrolment_id" :old_goal="goal" @dialog="onDialog" />
    <absence-modal 
      v-if="absenceDialogVisible"
      :dialogVisible="absenceDialogVisible"
      :absenceId="absence_id"
      @dialogVisible="onAbsenceDialogVisible"
    />
    <timetable-modal
      v-if="timetableDialogVisible"
      :dialogVisible="timetableDialogVisible"
      :student="student"
      :courseId="timetable.course_id"
      :timetableId="timetable.id"
      @dialogVisible="onTimetableDialogVisible"
    />
    <div class="content" style="background:#2CA8FF">
      <h4 class="text-center" style="color:#fff;margin:0;">
        <strong>Listado de alumnos</strong>
      </h4>
    </div>
    <el-table ref="students" :data="students" border fit style="width:100%;">
      <el-table-column align="center" label="Asistencia" width="140">
        <template slot-scope="scope">
          <el-radio-group
            v-model="scope.row.has_absence"
            :fill="scope.row.has_absence ? '#F56C6C':'#67C23A'"
            @change="scope.row.has_absence ? createAbsence(scope.row.enrolment_id) : deleteAbsence(scope.row.absence_id)"
          >
            <el-radio-button :label="false"><i class="el-icon-check" /></el-radio-button>
            <el-radio-button :label="true"><i class="el-icon-close" /></el-radio-button>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Deberes" width="200">
        <template slot-scope="scope">
          <el-radio-group
            v-model="scope.row.has_homework"
            :fill="scope.row.has_homework === true ? '#F56C6C' : scope.row.has_homework === 0 ? '#ffcc00' : '#67C23A'"
            @change="handleHomework(scope.row)"
          >
            <el-radio-button :label="false"><i class="el-icon-check" /></el-radio-button>
            <el-radio-button :label="true"><i class="el-icon-close" /></el-radio-button>
            <el-radio-button :label="0"><i class="el-icon-minus" /></el-radio-button>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Participación" width="140">
        <template slot-scope="scope">
          <el-radio-group
            v-model="scope.row.has_participation"
            :fill="scope.row.has_participation ? '#F56C6C' : '#67C23A'"
            @change="scope.row.has_participation ? createParticipation(scope.row.enrolment_id) : deleteParticipation(scope.row.participation_id)"
          >
            <el-radio-button :label="false"><i class="el-icon-check" /></el-radio-button>
            <el-radio-button :label="true"><i class="el-icon-close" /></el-radio-button>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Nombre" :width="isAdmin ? 300 : 'auto'">
        <template slot-scope="scope">
          <span>{{ scope.row.fullname }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Móvil" width="100" v-if="isAdmin">
        <template slot-scope="scope">
          <span>{{ scope.row.smartphone }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Email" v-if="isAdmin">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Estado" :width="isAdmin ? 300 : 'auto'" v-if="isAdmin">
        <template slot-scope="scope">
          <el-tag :type="scope.row.validated == 'Inscrito' ? '' : 'danger'" effect="plain">{{ scope.row.validated }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Rendimiento" width="auto" v-else>
        <template slot-scope="scope">
            {{
              scope.row.semaphore_color === 'green' ? 'Rendimiento actual excelente ' :
              scope.row.semaphore_color === 'yellow' ? 'Rendimiento actual mejorable' :
              scope.row.semaphore_color === 'red' ? 'Rendimiento actual insuficiente' :
              ''
            }}
          <div class="semaphore">
            <div :style="'background-color:' + (scope.row.semaphore_color === 'green' ? 'green !important' : 'black')"></div>
            <div :style="'background-color:' + (scope.row.semaphore_color === 'yellow' ? '#FFBF00 !important' : 'black')"></div>
            <div :style="'background-color:' + (scope.row.semaphore_color === 'red' ? 'red !important' : 'black')"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Objetivo" width="auto">
        <template slot-scope="scope">
          <span v-if="scope.row.goal && scope.row.goal != null">
            {{ scope.row.goal.level }} / {{ scope.row.goal.date != null ? new
            Date(scope.row.goal.date).toISOString().slice(0, 7) : '' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Opciones" width="130">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <el-button type="button" icon="el-icon-caret-bottom" />
            <el-dropdown-menu slot="dropdown">
               <template v-if="scope.row.prefix">
                 <a :href="'https://web.whatsapp.com/send?l=es&phone='+scope.row.prefix+scope.row.smartphone" target="_blank">
                  <el-dropdown-item v-if="isAdmin"><i class="fa fa-whatsapp" /> Whatsapp</el-dropdown-item>   
                 </a>
               </template>
               <template v-else>
                <a :href="'https://web.whatsapp.com/send?l=es&phone=34'+scope.row.smartphone" target="_blank">
                  <el-dropdown-item v-if="isAdmin"><i class="fa fa-whatsapp" /> Whatsapp</el-dropdown-item>   
                 </a>
               </template>
              <el-dropdown-item v-if="isAdmin" @click.native="openEmailModal(scope.row.id)"><i class="fa fa-envelope-open"/> Email</el-dropdown-item>
              <template v-if="scope.row.has_absence">
                <el-dropdown-item @click.native="openAbsenceModal(scope.row.absence_id)"><i class="el-icon-edit-outline" /> Añadir motivo de ausencia</el-dropdown-item>
              </template>
              <el-dropdown-item v-if="isAdmin" @click.native="openTimetableModal(scope.row)"><i class="el-icon-edit"/>
                Modificar Horario
              </el-dropdown-item>
              <a :href="'https://app.london-calling.es/online-chat/'+scope.row.id" target="_blank">
                  <el-dropdown-item><i class="fa fa-comments-o" /> Chat</el-dropdown-item>   
              </a>
              <el-dropdown-item @click.native="openGoalsModal(scope.row.enrolment_id, scope.row.goal)"><i class="fa fa-bullseye"/> Objetivos </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import CartCourse from './../CartCourse.vue';
  import EmailModal from './EmailModal.vue';
  import AbsenceModal from './AbsenceModal.vue';
  import TimetableModal from './TimetableModal.vue';
  import GoalsModal from './GoalsModal.vue';
  export default {
    props: ['timetable_id', 'date', 'isAdmin'],
    components: {
      CartCourse,
      EmailModal,
      AbsenceModal,
      TimetableModal,
      GoalsModal
    },
    data() {
      return {
        students: [],
        timetable: {},
        loading: false,
        dialogVisible: false,
        absenceDialogVisible: false,
        timetableDialogVisible: false,
        dialog: '',
        absence_id: '',
        user_id: '',
        student: {},
        enrolment_id: 0,
        goal: '',
        key: 0,
      };
    },
    created() {
      this.loading = true;
      this.getTimetable();
      this.getStudents();
    },
    methods: {
      createAbsence(enrolment_id) {
        axios.post('/absences', {
          'enrolment_id': enrolment_id,
          'description': '',
          'date': this.date,
        })
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      deleteAbsence(absence_id) {
        axios.delete(`/absences/${absence_id}`)
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleHomework(homework) {
        switch (true) {
          // Hizo los deberes
          case homework.has_homework === false && homework.homework_id != null:
            this.deleteHomework(homework.homework_id);
            break;
          // No hizo los deberes
          case homework.has_homework === true && homework.homework_id != null:
            let not_set = this.students.filter((student) => { return student.homework_id === homework.homework_id })[0].not_set_homework;
            if (not_set) {
              this.updateHomework(homework.homework_id, false);
            } else {
              this.createHomework(homework.homework_id, false);
            }
            break;
          case homework.has_homework === true && homework.homework_id == null:
            this.createHomework(homework.enrolment_id, false);
            break;
          // No marcó deberes
          case homework.has_homework === 0 && homework.homework_id == null:
            this.createHomework(homework.enrolment_id, true);
            break;
          case homework.has_homework === 0 && homework.homework_id != null:
            this.updateHomework(homework.homework_id, true);
            break;
          default:
            alert('No ha sucedido nada, contacte con administración y notifique la incidencia')
        }
      },
      createHomework(enrolment_id, not_set) {
        axios.post('/homework', {
          'enrolment_id': enrolment_id,
          'date': this.date,
          'not_set': not_set
        })
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      updateHomework(homework_id, not_set) {
        axios.put('/homework/' + homework_id, {
          'not_set': not_set
        })
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      deleteHomework(homework_id) {
        axios.delete(`/homework/${homework_id}`)
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      createParticipation(enrolment_id) {
        axios.post('/participation', {
          'enrolment_id': enrolment_id,
          'date': this.date,
        })
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      deleteParticipation(participation_id) {
        axios.delete(`/participation/${participation_id}`)
        .then(res => {
          this.getStudents();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      getTimetable() {
        axios.get(`/timetables-json/${this.timetable_id}`)
        .then(res => {
          this.timetable = res.data.data;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      getStudents() {
        axios.get('/students-json', {
          params: {
            'timetable_id': this.timetable_id,
            'date': this.date,
          }
        })
        .then(res => {
          this.students = res.data;
          this.loading = false;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      openEmailModal(user_id) {
        this.dialogVisible = true;
        this.user_id = user_id;
      },
      openGoalsModal(enrolment_id, goal) {
        this.enrolment_id = enrolment_id;
        this.goal = goal
        this.dialog = true;
      },
      openAbsenceModal(absence_id) {
        this.absenceDialogVisible = true;
        this.absence_id = absence_id;
      },
      openTimetableModal(student) {
        this.timetableDialogVisible = true;
        this.student = student;
      },
      onDialogVisible(value) {
        this.dialogVisible = false;
      },
      onDialog(value) {
        this.dialog = false;
        this.getStudents()
      },
      onAbsenceDialogVisible (value) {
        this.absenceDialogVisible = false;
      },
      onTimetableDialogVisible (value) {
        this.getStudents();
        this.key++;
        this.timetableDialogVisible = false;
      }
    },
  };
</script>
<style scoped>
.el-table .warning-row {
  background: oldlace;
}
table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.semaphore {
	width: 145px;
	height: 50px;
	border-radius: 5%;
	padding: 5px;
  display: flex;
  align-items: center;
}

.semaphore div {
	width: 12px !important;
	height: 12px;
	border-radius: 50%;
	margin: 5px;
	display: inline-block;
	border: none;
}

@media only screen and (max-width: 1200px) {
  .semaphore {
    float: left;
  }
}

@media only screen and (min-width: 1201px) {
  .semaphore {
    margin-left: 35%;
    margin-right: 35%;
  }
}
</style>